import { borderRadiusMixinPropsType, } from "../../mixins/borderRadius";
import { innerLayoutMixinPropsType, } from "../../mixins/innerLayout";
import { outerLayoutMixinPropsType, } from "../../mixins/outerLayout";
import { shadowMixinPropsType } from "../../mixins/shadow";
export const imageBoxPropsType = outerLayoutMixinPropsType
    .extend(innerLayoutMixinPropsType)
    .extend(shadowMixinPropsType)
    .extend(borderRadiusMixinPropsType)
    .complete({
    url: true,
    className: true,
    clickAction: true,
    clickActionIcon: true,
    children: true,
    loading: true,
    _objectFit: true,
    _objectPosition: true,
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHlwZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9JbWFnZUJveC90eXBlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFHQSxPQUFPLEVBRUwsMEJBQTBCLEdBQzNCLE1BQU0sMkJBQTJCLENBQUM7QUFDbkMsT0FBTyxFQUVMLHlCQUF5QixHQUMxQixNQUFNLDBCQUEwQixDQUFDO0FBR2xDLE9BQU8sRUFFTCx5QkFBeUIsR0FDMUIsTUFBTSwwQkFBMEIsQ0FBQztBQUNsQyxPQUFPLEVBQW9CLG9CQUFvQixFQUFFLE1BQU0scUJBQXFCLENBQUM7QUF3QjdFLE1BQU0sQ0FBQyxNQUFNLGlCQUFpQixHQUFHLHlCQUF5QjtLQUN2RCxNQUFNLENBQUMseUJBQXlCLENBQUM7S0FDakMsTUFBTSxDQUFDLG9CQUFvQixDQUFDO0tBQzVCLE1BQU0sQ0FBQywwQkFBMEIsQ0FBQztLQUNsQyxRQUFRLENBQWdCO0lBQ3ZCLEdBQUcsRUFBRSxJQUFJO0lBQ1QsU0FBUyxFQUFFLElBQUk7SUFDZixXQUFXLEVBQUUsSUFBSTtJQUNqQixlQUFlLEVBQUUsSUFBSTtJQUNyQixRQUFRLEVBQUUsSUFBSTtJQUNkLE9BQU8sRUFBRSxJQUFJO0lBQ2IsVUFBVSxFQUFFLElBQUk7SUFDaEIsZUFBZSxFQUFFLElBQUk7Q0FDdEIsQ0FBQyxDQUFDIn0=